module.exports = __webpack_public_path__ + "media/A49.627ea632.mp3";